// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getBreadcrumbListActiveState from "@awc/App/Widgets/SearchEngineOptimization/ActiveState/BreadcrumbList";
import { SeoAppProps, SeoHandlerProps } from "@awc/App/Widgets/SearchEngineOptimization/Type";
import { BreadcrumbList, WithContext } from "@awc/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaBreadcrumbList = ({ state }: SeoAppProps): WithContext<BreadcrumbList> => {
    const url = state?.context?.website?.uri?.split("/")?.splice(0, 3)?.join("/");

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: state?.components?.breadcrumbs?.links?.map((item, index) => {
            const itemHref = item.href ? `${url}${item.href}` : url;
            const itemName = item.children ? item.children : "";
            return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": itemHref,
                    name: itemName,
                },
            };
        }),
    };
};

export default {
    isActivate: getBreadcrumbListActiveState,
    buildSchema: loadSchemaBreadcrumbList,
} as SeoHandlerProps;
